import { Button as ButtonBase, } from "@single-js/common/components/button/button";
import * as React from "react";
export const Button = (props) => {
    return React.createElement(ButtonBase, { ...props });
};
